export default `float lightAt(vec2 nuv) {
  vec2 src = vec2(1.02, 1.06); 
  float d = distance(nuv, src);
  return clamp(1.15 - d * 0.92, 0.0, 1.2);
}

float grazing(vec3 normal, vec3 lightDir) {
  float diff = max(dot(normalize(normal), normalize(lightDir)), 0.0);
  return clamp(diff * 0.8 + 0.2, 0.0, 1.0);
}
float contourLine(float h, float freq, float thickness) {
  float scaled = h * freq;
  float f = fract(scaled);
  
  float dist = min(f, 1.0 - f);
  float aa = fwidth(scaled) * 1.2 + 1e-5;
  
  return 1.0 - smoothstep(thickness * 0.5, thickness * 0.5 + aa, dist);
}

uniform float uTime;
uniform float uContourFrequency;
uniform float uContourThickness;
uniform vec3  uContourColor;
uniform float uDotDensity;
uniform float uDotSize;
uniform float uDotIntensity;
uniform float uDotFlicker;
uniform float uDotBand;   
uniform vec3  uDotColor;
uniform vec3  uBaseColor;
uniform vec3  uAmber;
uniform vec3  uHazeColor;
uniform float uHazeDensity;
uniform vec3  uLightDir;
uniform vec3  uCameraPos;
uniform float uWorldSize;
uniform float uPathValleyWidth;
uniform float uReveal;
uniform float uStrataAmount;
uniform float uStrataStep;
uniform float uRipple;     
uniform float uAudioLevel; 

varying vec3  vWorldPos;
varying float vElevation;
varying float vPathDist;

float hash21(vec2 p) {
  p = fract(p * vec2(123.34, 345.45));
  p += dot(p, p + 34.345);
  return fract(p.x * p.y);
}

void main() {
  
  vec3 n = normalize(cross(dFdx(vWorldPos), dFdy(vWorldPos)));
  float graze = grazing(n, uLightDir);

  
  vec2 luv = vWorldPos.xz / uWorldSize + 0.5;
  float lg = lightAt(luv);

  float pathEmph = 1.0 - smoothstep(0.0, uPathValleyWidth * 1.4, vPathDist);

  
  vec3 col = uBaseColor * (0.45 + 0.65 * graze) * (0.55 + 0.55 * lg);

  
  
  
  float c = contourLine(vElevation, uContourFrequency, uContourThickness);
  col += uContourColor * c * (0.12 + 0.4 * lg) * graze * 0.2;
  col += uAmber * pathEmph * 0.05;

  
  
  
  float band = contourLine(vElevation, uContourFrequency, uContourThickness * uDotBand);
  vec2 g = vWorldPos.xz * uDotDensity;
  vec2 cell = floor(g);
  vec2 f = fract(g) - 0.5;
  float rnd = hash21(cell);
  float dotShape = 1.0 - smoothstep(uDotSize * 0.35, uDotSize, length(f));
  float dots = dotShape * step(0.5, rnd) * (0.14 + 0.86 * band);
  float flick = 1.0 - uDotFlicker * (0.5 + 0.5 * sin(uTime * 2.0 + rnd * 40.0));
  col += uDotColor * dots * uDotIntensity * (0.45 + 0.75 * lg) * flick
         * (0.75 + 0.5 * pathEmph) * (1.0 + uAudioLevel * uRipple * 0.9);

  
  
  if (uStrataAmount > 0.001) {
    col *= (1.0 - 0.55 * uStrataAmount);
    float band = contourLine(vWorldPos.y, 1.0 / uStrataStep, uContourThickness * 3.0);
    col += uContourColor * band * uStrataAmount * (0.5 + 0.6 * lg) * (0.4 + 0.6 * graze);
  }

  
  float dist = distance(vWorldPos, uCameraPos);
  float fog = 1.0 - exp(-uHazeDensity * dist);
  col = mix(col, uHazeColor, clamp(fog, 0.0, 1.0));

  
  
  col *= (0.62 + 0.38 * uReveal);

  gl_FragColor = vec4(col, 1.0);
}`